import {
  LOAD_COMPANY_BILLING_SUCCESS,
  LOAD_COMPANY_RATE_SUCCESS,
  INVOICE_COMPANY_SUCCESS,
  PAYMENT_SUCCESS,
} from 'constants/ActionTypes';
import { fromJS } from 'immutable';
import { getJwtToken, normalizeEntities } from 'helpers/utilHelpers';
import { backendUrl } from 'util/config';

const initialState = fromJS({
  billing: {
    billingItems: {},
    pagination: {
      totalCount: null,
      pageCount: null,
      currentPage: null,
      perPage: null,
    },
  },
  rate: {},
  invoice: {
    url: null,
  },
});

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_COMPANY_BILLING_SUCCESS: {
      return state
        .setIn(
          ['billing', 'billingItems'],
          normalizeEntities(action.billing.items, 'billId', state.getIn(['billing', 'billingItems'])),
        )
        .setIn(
          ['billing', 'pagination'],
          fromJS({
            totalCount: action.billing._meta.totalCount,
            pageCount: action.billing._meta.pageCount,
            currentPage: action.billing._meta.currentPage,
            perPage: action.billing._meta.perPage,
          }),
        );
    }
    case LOAD_COMPANY_RATE_SUCCESS:
      return state.set('rate', normalizeEntities(action.rates.items, 'rateId', state.get('rate')));
    case INVOICE_COMPANY_SUCCESS: {
      const billId = action.invoice.billId;
      const token = getJwtToken({ action: 'download', companyId: action.invoice.companyId });
      const url = `${backendUrl}/user/backend/user-company-billing/download?billId=${billId}&token=${token}`;

      return state.setIn(['billing', 'billingItems', billId], fromJS(action.invoice)).setIn(['invoice', 'url'], url);
    }
    case PAYMENT_SUCCESS: {
      const item = state.getIn(['billing', 'billingItems', action.billId]);
      if (item?.get('status') === 'pending') {
        return state.setIn(['billing', 'billingItems', action.billId, 'status'], 'processing');
      }
      return state;
    }

    default:
      return state;
  }
};

export default companyReducer;
